import { Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FieldConfig } from '@smartflip/data-models';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  imports: [ReactiveFormsModule, IonicModule],
})
export class RadioButtonComponent {
  field: FieldConfig;
  group: UntypedFormGroup;

  public getFieldOptions(field: FieldConfig) {
    return field.options.map((option) => option as string);
  }
}
